import { CSSProperties } from 'react';
import ReactQuill from 'react-quill';
import styles from './ContactForm/ContactForm.module.css';

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['link', 'image'],
    ['clean'],
  ],
};
type EditorProps = {
  value: string;
  onChange: (value: string) => void;
  style?: CSSProperties;
};

const Editor = ({ value, onChange }: EditorProps) => {
  return (
    <ReactQuill
      value={value}
      onChange={onChange}
      modules={modules}
      theme={'snow'}
      className={styles.blogSection}
    />
  );
};

export default Editor;
